<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre2"><br/>
<br/></p>
<h1 class="sgc-1 sigilNotInTOC" id="heading_id_2">Dedication<br/>
<br/>
<br/>
<br/></h1>
<p class="calibre10 sgc-6">For Mechthild Gawlick<br/>
  Who turns to engage me unreservedly<br/>
  On the “narrow ridge” of genuine dialogue.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?09ba747a